import { render, staticRenderFns } from "./PriceManagementPower.vue?vue&type=template&id=276285cc&"
import script from "./PriceManagementPower.vue?vue&type=script&lang=js&"
export * from "./PriceManagementPower.vue?vue&type=script&lang=js&"
import style0 from "./PriceManagementPower.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports